<template>
    <li class="relative header__actions-item hover-menu">
        <button
            type="button"
            class="profile-button group flex items-center gap-[6px] px-[10px] py-[6px] rounded-[6px] bg-[#F7F7FC] hover:bg-[#273276] hover:stroke-white transition-colors text-[12px] leading-[16px] group"
            :title="!signedIn ? in18.login : profileTitle"
            @click="toggleMobileDropdown()"
        >
            <svg
                class="profile-icon stroke-[#273276] transition-colors group-hover:stroke-white"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M12 12.0002C14.5717 12.0002 16.6565 9.91535 16.6565 7.34359C16.6565 4.77183 14.5717 2.68701 12 2.68701C9.42821 2.68701 7.34338 4.77183 7.34338 7.34359C7.34338 9.91535 9.42821 12.0002 12 12.0002Z"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20 21.3132C20 17.709 16.4144 14.7939 12 14.7939C7.58556 14.7939 4 17.709 4 21.3132"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <span class="hidden transition-colors profile-text lg:block group-hover:text-white">
                {{signedIn ? profileText : in18.login}}
            </span>
        </button>

        <!-- Dropdown Menu with invisible bridge -->
        <div
            class="absolute right-0 top-full w-full h-[10px] hidden lg:block"
        ></div>
        <div
            v-if="signedIn"
            class="profile-dropdown absolute right-0 top-[calc(100%+10px)] w-[220px] bg-[#F7F7FC] rounded-[8px] overflow-hidden z-50 hidden"
        >
            <div class="flex flex-col p-4 gap-[6px]" ref="dropdownContent">
                <a
                    :href="profileRoute"
                    class="flex items-center px-[12px] py-[8px] text-[15px] leading-[20px] text-gray-800 rounded-[8px] gap-[8px] hover:bg-white"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="23"
                        viewBox="0 0 23 23"
                        fill="none"
                    >
                        <path
                            d="M18.0252 3.50568L19.9146 1.61515C20.3085 1.22128 20.8427 1 21.3998 1C21.9568 1 22.491 1.22128 22.8849 1.61515C23.2787 2.00902 23.5 2.54323 23.5 3.10025C23.5 3.65727 23.2787 4.19148 22.8849 4.58535L10.9917 16.4785C10.3996 17.0702 9.66944 17.5052 8.86712 17.7441L5.85996 18.64L6.75594 15.6329C6.99481 14.8306 7.42977 14.1004 8.02153 13.5083L18.0252 3.50568ZM18.0252 3.50568L20.9798 6.4602M19.2998 14.1601V19.48C19.2998 20.1484 19.0343 20.7893 18.5617 21.2619C18.0891 21.7345 17.4481 22 16.7798 22H5.01997C4.35163 22 3.71067 21.7345 3.23808 21.2619C2.7655 20.7893 2.5 20.1484 2.5 19.48V7.72019C2.5 7.05185 2.7655 6.41089 3.23808 5.9383C3.71067 5.46572 4.35163 5.20022 5.01997 5.20022H10.3399"
                            stroke="#606060"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    <span>{{ editProfileName }}</span>
                </a>
                <a
                    :href="changePasswordRoute"
                    class="flex gap-[8px] items-center px-[12px] py-[8px] text-[15px] leading-[20px] text-gray-800 rounded-[8px] hover:bg-white"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="23"
                        viewBox="0 0 23 23"
                        fill="none"
                    >
                        <path
                            d="M11.4999 1.09961C13.1257 1.09961 14.6594 1.69368 15.8553 2.77832L16.0907 3.00098C17.3171 4.22734 17.9921 5.85758 17.9921 7.5918V9.5459C17.9921 9.89497 17.7083 10.1787 17.3593 10.1787C17.0102 10.1787 16.7264 9.89495 16.7264 9.5459V7.5918C16.7264 4.70942 14.3823 2.36523 11.4999 2.36523C8.61751 2.36525 6.27333 4.70943 6.27332 7.5918V9.5459C6.27332 9.89497 5.98957 10.1787 5.6405 10.1787C5.29143 10.1787 5.00769 9.89497 5.00769 9.5459V7.5918C5.0077 5.85758 5.6827 4.22734 6.90906 3.00098C8.13542 1.77462 9.76566 1.09962 11.4999 1.09961Z"
                            fill="#606060"
                            stroke="white"
                            stroke-width="0.2"
                        />
                        <path
                            d="M7.5946 8.91309H15.4081C16.6639 8.91309 17.6068 8.91341 18.3846 8.98926L18.7079 9.02637C19.567 9.1426 20.1796 9.37939 20.6591 9.77637L20.8573 9.95605C21.3013 10.4001 21.5804 10.9611 21.7303 11.752L21.787 12.1045V12.1055C21.9001 12.9439 21.9003 13.9702 21.9003 15.4053C21.9003 16.6612 21.8999 17.604 21.8241 18.3818L21.787 18.7051C21.6707 19.5643 21.434 20.1768 21.037 20.6562L20.8573 20.8545C20.4133 21.2985 19.8523 21.5776 19.0614 21.7275L18.7089 21.7842H18.7079C17.8665 21.8973 16.8401 21.8975 15.4052 21.8975H7.5946C6.3387 21.8975 5.39586 21.8971 4.61804 21.8213L4.2948 21.7842C3.43561 21.6679 2.8231 21.4312 2.34363 21.0342L2.14539 20.8545C1.69889 20.408 1.42173 19.849 1.27234 19.0586L1.21667 18.7061L1.2157 18.7051L1.17859 18.3818C1.10274 17.604 1.10242 16.6612 1.10242 15.4053C1.10242 14.1494 1.10273 13.2065 1.17859 12.4287L1.2157 12.1055C1.34855 11.1235 1.63816 10.4633 2.14539 9.95605C2.59189 9.50955 3.15091 9.2324 3.94128 9.08301L4.29382 9.02734L4.2948 9.02637C5.13322 8.91326 6.15956 8.91309 7.5946 8.91309ZM7.5946 10.1787C6.3183 10.1787 5.35147 10.1784 4.6239 10.2598C3.98783 10.3309 3.51765 10.4653 3.17859 10.7305L3.04089 10.8525C2.69579 11.1994 2.53168 11.7099 2.45007 12.4365C2.36837 13.1641 2.36804 14.1303 2.36804 15.4053C2.36804 16.6802 2.36776 17.6471 2.4491 18.375C2.53035 19.1022 2.69471 19.6134 3.04187 19.959V19.958C3.38882 20.305 3.89901 20.4695 4.62585 20.5508C5.35343 20.6321 6.31972 20.6318 7.5946 20.6318H15.4081C16.6843 20.6318 17.6512 20.6321 18.3788 20.5508C19.1057 20.4695 19.6162 20.3051 19.9618 19.958L19.9608 19.957C20.3074 19.6101 20.4724 19.1006 20.5536 18.374C20.6349 17.6464 20.6346 16.6802 20.6346 15.4053C20.6346 14.1304 20.6349 13.1635 20.5536 12.4355C20.4825 11.7992 20.3481 11.3285 20.0829 10.9893L19.9608 10.8516C19.6139 10.5065 19.1035 10.3423 18.3768 10.2607C17.6492 10.179 16.6831 10.1787 15.4081 10.1787H7.5946Z"
                            fill="#606060"
                            stroke="white"
                            stroke-width="0.2"
                        />
                        <path
                            d="M7.5946 14.5327H7.60339C8.08723 14.5327 8.47937 14.9249 8.47937 15.4087C8.47937 15.8925 8.08723 16.2847 7.60339 16.2847H7.5946C7.11077 16.2847 6.71863 15.8925 6.71863 15.4087C6.71863 14.9249 7.11077 14.5327 7.5946 14.5327ZM11.4911 14.5327H11.4999C11.9837 14.5327 12.3759 14.9249 12.3759 15.4087C12.3759 15.8925 11.9837 16.2847 11.4999 16.2847H11.4911C11.0073 16.2847 10.6151 15.8925 10.6151 15.4087C10.6151 14.9552 10.9597 14.5825 11.4012 14.5376L11.4911 14.5327ZM15.3964 14.5298H15.4052C15.889 14.5298 16.2811 14.9219 16.2811 15.4058C16.2811 15.89 15.8886 16.2847 15.4052 16.2847H15.3964C14.9125 16.2846 14.5204 15.8925 14.5204 15.4087C14.5204 14.9245 14.9129 14.5298 15.3964 14.5298Z"
                            fill="#606060"
                            stroke="white"
                            stroke-width="0.2"
                        />
                    </svg>
                    <span>{{ changePasswordName }}</span>
                </a>
                <a
                    href="#"
                    @click="logout"
                    class="flex gap-[8px] items-center px-[12px] py-[8px] text-[15px] leading-[20px] text-gray-800 rounded-[8px] hover:bg-white"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M10.8825 20.4113H5.98606C4.65538 20.4113 3.5757 19.3145 3.5757 17.9718V6.02823C3.5757 4.68145 4.65936 3.58871 5.98606 3.58871H10.9622C11.261 3.58871 11.5 3.34677 11.5 3.04435C11.5 2.74194 11.261 2.5 10.9622 2.5H5.98606C4.06175 2.5 2.5 4.08468 2.5 6.02823V17.9718C2.5 19.9194 4.06574 21.5 5.98606 21.5H10.8825C11.1813 21.5 11.4203 21.2581 11.4203 20.9556C11.4203 20.6532 11.1773 20.4113 10.8825 20.4113Z"
                            fill="#606060"
                        />
                        <path
                            d="M21.3336 11.5648L17.7314 7.67998C17.5089 7.44001 17.1521 7.44001 16.9295 7.67998C16.707 7.91995 16.707 8.3048 16.9295 8.54477L19.5661 11.3882H8.06678C7.7519 11.3882 7.5 11.6599 7.5 11.9994C7.5 12.339 7.7519 12.6107 8.06678 12.6107H19.5661L16.9295 15.4541C16.707 15.6941 16.707 16.0789 16.9295 16.3189C17.0387 16.4366 17.1856 16.5 17.3284 16.5C17.4711 16.5 17.6181 16.4411 17.7272 16.3189L21.3294 12.4341C21.5562 12.1896 21.5561 11.8002 21.3336 11.5648Z"
                            fill="#606060"
                        />
                    </svg>
                    <span>{{ logoutName }}</span>
                </a>
                <form
                    id="logout-form"
                    method="POST"
                    :action="logoutRoute"
                    class="d-none"
                >
                    <slot name="csrf"></slot>
                </form>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: "HeaderProfileDropdown",
    props: {
        profileText: {
            type: String,
            required: true,
        },
        profileTitle: {
            type: String,
            required: true,
        },
        profileRoute: {
            type: String,
            required: true,
        },
        changePasswordRoute: {
            type: String,
            required: true,
        },
        logoutRoute: {
            type: String,
            required: true,
        },
        loginRoute: {
            type: String,
            required: true,
        },
        editProfileName: {
            type: String,
            default: "Edit profile",
        },
        changePasswordName: {
            type: String,
            default: "Change password",
        },
        logoutName: {
            type: String,
            default: "Logout",
        },
        initialCode: {
            type: String,
            default: "",
        },
        in18: {
            type: Object,
            required: true,
        },
        signedIn: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            isMobile: false,
            mobileDropdownVisible: false,
            countries: [],
            selected: { code: this.initialCode, title: "" },
        };
    },
    mounted() {
        this.setupHoverBehavior();
        this.checkScreenSize();
        window.addEventListener("resize", this.checkScreenSize);

        if (!this.countries.length) {
            this.fetchCountries();
            this.selected = this.countries.find(
                (c) => c.code === this.selected.code
            );
        }

        // Create mobile sidebar container if it doesn't exist
        if (!document.getElementById("mobile-sidebar-container")) {
            const container = document.createElement("div");
            container.id = "mobile-sidebar-container";
            document.body.appendChild(container);
        }
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkScreenSize);
        // Clean up any mobile sidebar elements when component is destroyed
        this.removeMobileSidebar();
    },
    methods: {
        fetchCountries() {
            this.loading = true;
            axios
                .get("/api/shipping/countries")
                .then((r) => {
                    this.countries = r.data.countries;
                    const found = this.countries.find(
                        (c) => c.code === this.initialCode
                    );
                    if (found) this.selected = found;
                })
                .catch(console.error)
                .finally(() => (this.loading = false));
        },
        handleChangeAddress() {
            this.$emit("change-address");
            this.removeMobileSidebar();
        },
        setupHoverBehavior() {
            const hoverMenu = this.$el;
            const profileButton = this.$el.querySelector(".profile-button");
            const profileIcon = this.$el.querySelector(".profile-icon");
            const profileText = this.$el.querySelector(".profile-text");
            const profileDropdown = this.$el.querySelector(".profile-dropdown");

            if (hoverMenu && profileButton && profileDropdown) {
                // Show dropdown and change button style on hover (only on desktop)
                hoverMenu.addEventListener("mouseenter", () => {
                    if (!this.isMobile) {
                        profileButton.classList.add("bg-[#273276]");
                        profileButton.classList.remove("bg-[#F7F7FC]");
                        profileIcon.classList.add("stroke-white");
                        profileIcon.classList.remove("stroke-[#273276]");
                        profileText.classList.add("text-white");
                        profileDropdown.classList.remove("hidden");
                    }
                });

                // Hide dropdown and revert button style when not hovering (only on desktop)
                hoverMenu.addEventListener("mouseleave", () => {
                    if (!this.isMobile) {
                        profileButton.classList.remove("bg-[#273276]");
                        profileButton.classList.add("bg-[#F7F7FC]");
                        profileIcon.classList.remove("stroke-white");
                        profileIcon.classList.add("stroke-[#273276]");
                        profileText.classList.remove("text-white");
                        profileDropdown.classList.add("hidden");
                    }
                });
            }
        },
        logout(event) {
            event.preventDefault();
            document.getElementById("logout-form").submit();
        },
        login() {
            window.location.href = this.loginRoute;
        },
        checkScreenSize() {
            this.isMobile = window.innerWidth < 1024; // lg breakpoint is typically 1024px
        },
        toggleMobileDropdown() {
            if (!this.isMobile){
                if (!this.signedIn){
                    this.login();
                }
                return;
            }
            if (this.mobileDropdownVisible) {
                this.closeMobileDropdown();
            } else {
                this.openMobileDropdown();
            }
        },
        openMobileDropdown() {
            // Create backdrop
            const backdrop = document.createElement("div");
            backdrop.id = "mobile-profile-backdrop";
            backdrop.className =
                "fixed inset-0 bg-black bg-opacity-50 z-[9998]";
            backdrop.addEventListener("click", this.closeMobileDropdown);
            document.body.appendChild(backdrop);

            // Create sidebar
            const sidebar = document.createElement("div");
            sidebar.id = "mobile-profile-sidebar";
            sidebar.className =
                "fixed left-0 top-0 bottom-0 pt-[24px] px-[16px] max-w-[330px] w-full bg-white z-[9999] transform transition-transform duration-300";

            // Header
            const headerDiv = document.createElement("div");
            headerDiv.className =
                "flex justify-between items-center pb-[12px] mb-[12px] border-b";

            const title = document.createElement("h2");
            title.className =
                "text-[15px] font-semibold leading-[22.5px] text-[#606060]";
            title.textContent = this.profileText;

            const closeBtn = document.createElement("button");
            closeBtn.className = "w-[24px] h-[24px] rounded-[6px] flex items-center justify-center bg-[#F7F7FC] hover:bg-[#273276] transition-all text-[#606060] hover:text-white";
            closeBtn.innerHTML =
                '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.09938 6.49997L11.7719 1.82726C12.076 1.52332 12.076 1.0319 11.7719 0.727955C11.468 0.424015 10.9766 0.424015 10.6726 0.727955L5.99993 5.40066L1.32737 0.727955C1.02329 0.424015 0.532002 0.424015 0.228062 0.727955C-0.0760206 1.0319 -0.0760206 1.52332 0.228062 1.82726L4.90062 6.49997L0.228062 11.1727C-0.0760206 11.4766 -0.0760206 11.968 0.228062 12.272C0.379534 12.4236 0.578696 12.4998 0.777716 12.4998C0.976737 12.4998 1.17576 12.4236 1.32737 12.272L5.99993 7.59928L10.6726 12.272C10.8243 12.4236 11.0233 12.4998 11.2223 12.4998C11.4213 12.4998 11.6203 12.4236 11.7719 12.272C12.076 11.968 12.076 11.4766 11.7719 11.1727L7.09938 6.49997Z" fill="currentColor" /></svg>';
            closeBtn.addEventListener("click", this.closeMobileDropdown);

            headerDiv.appendChild(title);
            headerDiv.appendChild(closeBtn);
            sidebar.appendChild(headerDiv);

            // Content
            const contentDiv = document.createElement("div");
            contentDiv.className = "flex flex-col pt-[12px] gap-[20px]";

            const changeCountryButton = document.createElement("button");
            changeCountryButton.type = "button";
            changeCountryButton.addEventListener("click", this.handleChangeAddress);
            changeCountryButton.className =
                "flex h-[54px] overflow-hidden group items-center gap-[10px] cursor-pointer px-[12px] text-[#252525] bg-[#FAFAFA] hover:bg-[#F7F7FC] hover:border-transparent border border-[#EFEEEE] rounded-[6px]";
            
            // Create the button content with a more controlled layout
            const iconSvg = document.createElement("div");
            iconSvg.className = "flex-shrink-0";
            iconSvg.innerHTML = `<svg class="min-w-[24px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
                <path d="M7.99992 8.95346C9.14867 8.95346 10.0799 8.02221 10.0799 6.87346C10.0799 5.72471 9.14867 4.79346 7.99992 4.79346C6.85117 4.79346 5.91992 5.72471 5.91992 6.87346C5.91992 8.02221 6.85117 8.95346 7.99992 8.95346Z" stroke="#252525"/>
                <path d="M2.41345 5.66016C3.72679 -0.113169 12.2801 -0.106503 13.5868 5.66683C14.3535 9.0535 12.2468 11.9202 10.4001 13.6935C9.06012 14.9868 6.94012 14.9868 5.59345 13.6935C3.75345 11.9202 1.64679 9.04683 2.41345 5.66016Z" stroke="#252525"/>
            </svg>`;
            
            const contentWrapper = document.createElement("div");
            contentWrapper.className = "flex items-center w-full min-w-0";
            
            const addressDiv = document.createElement("div");
            addressDiv.className = "h-[44px] items-start justify-center flex flex-col text-[14px] min-w-0 max-w-[60%] overflow-hidden";
            
            // Break down into separate elements for better truncation control
            const deliverToSpan = document.createElement("span");
            deliverToSpan.textContent = this.in18["cs_deliver_to"];
            
            const titleContainer = document.createElement("div");
            titleContainer.className = "w-full text-left overflow-hidden text-ellipsis whitespace-nowrap";
            
            const titleSpan = document.createElement("span");
            titleSpan.className = "font-medium";
            titleSpan.textContent = this.selected?.title || '';
            
            titleContainer.appendChild(titleSpan);
            addressDiv.appendChild(deliverToSpan);
            addressDiv.appendChild(titleContainer);
            
            const actionButton = document.createElement("div");
            actionButton.className = "h-[28px] px-[10px] ml-auto flex-shrink-0 flex items-center justify-center text-[14px] rounded-[6px] bg-[#273276] text-white whitespace-nowrap";
            actionButton.innerHTML = `<span>${this.in18["cs_change_address_short"]}</span>`;
            
            // Assemble the components
            contentWrapper.appendChild(addressDiv);
            contentWrapper.appendChild(actionButton);
            
            changeCountryButton.appendChild(iconSvg);
            changeCountryButton.appendChild(contentWrapper);
            contentDiv.appendChild(changeCountryButton);

            // Edit profile link
            const editProfileLink = document.createElement("a");
            editProfileLink.href = this.profileRoute;
            editProfileLink.className =
                "flex items-center text-gray-800 rounded-lg gap-3 text-[#252525] mb-[4px]";
            editProfileLink.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#606060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18.0252 3.50568L19.9146 1.61515C20.3085 1.22128 20.8427 1 21.3998 1C21.9568 1 22.491 1.22128 22.8849 1.61515C23.2787 2.00902 23.5 2.54323 23.5 3.10025C23.5 3.65727 23.2787 4.19148 22.8849 4.58535L10.9917 16.4785C10.3996 17.0702 9.66944 17.5052 8.86712 17.7441L5.85996 18.64L6.75594 15.6329C6.99481 14.8306 7.42977 14.1004 8.02153 13.5083L18.0252 3.50568ZM18.0252 3.50568L20.9798 6.4602M19.2998 14.1601V19.48C19.2998 20.1484 19.0343 20.7893 18.5617 21.2619C18.0891 21.7345 17.4481 22 16.7798 22H5.01997C4.35163 22 3.71067 21.7345 3.23808 21.2619C2.7655 20.7893 2.5 20.1484 2.5 19.48V7.72019C2.5 7.05185 2.7655 6.41089 3.23808 5.9383C3.71067 5.46572 4.35163 5.20022 5.01997 5.20022H10.3399" />
        </svg>
        ${this.editProfileName}
      `;
            if (this.signedIn) {
                contentDiv.appendChild(editProfileLink);
            }

            // Change password link
            const changePasswordLink = document.createElement("a");
            changePasswordLink.href = this.changePasswordRoute;
            changePasswordLink.className =
                "flex gap-3 items-center text-gray-800 rounded-lg text-[#252525]";
            changePasswordLink.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#606060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
        ${this.changePasswordName}
      `;
            if (this.signedIn) {
                contentDiv.appendChild(changePasswordLink);
            }

            // Logout link with handler
            const logoutLink = document.createElement("a");
            logoutLink.href = "#";
            logoutLink.className =
                "flex gap-3 items-center text-gray-800 rounded-lg text-[#252525]";
            logoutLink.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#606060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
        ${this.logoutName}
      `;
            logoutLink.addEventListener("click", this.logout);
            if (this.signedIn) {
                contentDiv.appendChild(logoutLink);
            }

            // login link with handler
            const loginLink = document.createElement("a");
            loginLink.href = "#";
            loginLink.className =
                "flex gap-3 items-center text-gray-800 rounded-lg text-[#252525]";
            loginLink.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M15 4H18C19.1046 4 20 4.89543 20 6L20 18C20 19.1046 19.1046 20 18 20H15M11 16L15 12M15 12L11 8M15 12H3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        ${this.in18.login}
      `;
            loginLink.addEventListener("click", this.login);
            if (!this.signedIn) {
                contentDiv.appendChild(loginLink);
            }

            sidebar.appendChild(contentDiv);
            document.body.appendChild(sidebar);

            // Animation: slide in from left
            setTimeout(() => {
                sidebar.classList.add("translate-x-0");
            }, 10);
        },
        closeMobileDropdown() {
            const backdrop = document.getElementById("mobile-profile-backdrop");
            if (backdrop) {
                document.body.removeChild(backdrop);
            }

            const sidebar = document.getElementById("mobile-profile-sidebar");
            if (sidebar) {
                sidebar.classList.add("translate-x-full");
                setTimeout(() => {
                    if (sidebar && sidebar.parentNode) {
                        document.body.removeChild(sidebar);
                    }
                }, 300);
            }

            this.mobileDropdownVisible = false;
        },
        removeMobileSidebar() {
            const backdrop = document.getElementById("mobile-profile-backdrop");
            if (backdrop) {
                document.body.removeChild(backdrop);
            }

            const sidebar = document.getElementById("mobile-profile-sidebar");
            if (sidebar) {
                document.body.removeChild(sidebar);
            }
        },
    },
};
</script>

<style>
#mobile-profile-sidebar {
    transform: translateX(-100%);
    transition: transform 0.3s ease;
}
#mobile-profile-sidebar.translate-x-0 {
    transform: translateX(0);
}
#mobile-profile-sidebar.translate-x-full {
    transform: translateX(-100%);
}
</style>
